import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt } from '@fortawesome/pro-light-svg-icons'

import { Box, Button } from '@domain-group/suit-theme'

interface CampaignTimelineNoticeProps {
  boxProps?: object,
  callbacks: {
    editCampaignDates: VoidFunction,
  },
  campaignStartDate?: string,
  loading: boolean,
}

const CampaignTimelineNotice = (props: CampaignTimelineNoticeProps) => {
  const {
    boxProps,
    callbacks: {
      editCampaignDates,
    },
    campaignStartDate,
    loading,
  } = props

  if (loading || !!campaignStartDate){
    return null
  }

  return (
    <Box
      alignItems={['flex-start', 'center']}
      backgroundColor="white"
      border="1px solid"
      borderColor="lineColor"
      borderRadius={5}
      flexDirection={['column', 'row']}
      fontSize="small"
      padding="large"
      {...boxProps}
    >
      <Box alignItems="center">
        <Box color="bodyFontLightColor" fontSize="xlarge" width="auto">
          <FontAwesomeIcon icon={faCalendarAlt} />
        </Box>

        <Box flexDirection={['column', 'row']} flexWrap="wrap" marginLeft="large">
          Campaign dates are required but not set
        </Box>
      </Box>

      <Box
        borderTop={['1px dashed', 'none']}
        borderColor="lineColor"
        paddingTop={['large', 0]}
        marginTop={['large', 0]}
      >
        <Button
          buttonStyle="primaryEdit"
          // @ts-expect-error TS2322
          marginLeft="auto"
          onClick={editCampaignDates}
          size="medium"
          width="auto"
        >
          Edit Dates
        </Button>
      </Box>
    </Box>
  )
}

export default CampaignTimelineNotice
